import React, { useCallback, useMemo, useState } from "react";
import { Carousel, Container, Row, Col, Modal, Ratio } from "react-bootstrap";
import bg1 from "../assets/image/bg1.png";
import { PlaySVG } from "./SvgIcons";
import { isEnabled } from "../lib/promoFlags";

function BannerSlider({ hero = null, slideTextEnabled = true }) {
  const slides = (hero?.images || []).length
    ? hero.images.map((item) => ({
        city: hero?.tagline || "Lorem Ipsum",
        title: item.title || hero?.title || "Find Your Next Holiday Cool Packages!",
        image: item.url,
      }))
    : [
        {
          city: "Lorem Ipsum",
          title: "Find Your Next Holiday Cool Packages!",
          image: bg1,
        },
      ];

  const [activeIndex, setActiveIndex] = useState(0);
  const [showVideo, setShowVideo] = useState(false);

  const handleSelect = useCallback((index) => {
    setActiveIndex(index);
  }, []);

  const goPrev = useCallback(() => {
    setActiveIndex((prev) =>
      prev === 0 ? slides.length - 1 : prev - 1
    );
  }, [slides.length]);

  const goNext = useCallback(() => {
    setActiveIndex((prev) =>
      prev === slides.length - 1 ? 0 : prev + 1
    );
  }, [slides.length]);

  const progressPercent = useMemo(() => {
    return ((activeIndex + 1) / slides.length) * 100;
  }, [activeIndex, slides.length]);

  const openYoutube = (e) => {
    e.preventDefault();
    setShowVideo(true);
  };

  const closeYoutube = () => setShowVideo(false);

  const youtubeUrl = hero?.watch_culture_url || "https://www.youtube.com/watch?v=ys8v5wAPF1w";
  const youtubeEmbedUrl = toEmbedUrl(youtubeUrl);
  const showSlideText = isEnabled(slideTextEnabled, true);
  const showWatchCulture = isEnabled(hero?.show_watch_culture, Boolean(youtubeUrl));

  return (
    <div className="banner-slider-wrap">
      <Carousel
        fade
        interval={5000}
        controls={false}
        indicators={false}
        activeIndex={activeIndex}
        onSelect={handleSelect}
      >
        {slides.map((s, idx) => (
          <Carousel.Item key={idx}>
            <div
              className="banner-slide"
              style={{
                backgroundImage: `linear-gradient(rgba(34,34,34,0.5), rgba(34,34,34,0.5)), url(${s.image})`,
              }}
            >
              {showSlideText ? (
                <div className="banner-content-wrap">
                  <Container>
                    <Row>
                      <Col lg={12}>
                        <div className="banner-content banner-text-enter">
                          <div className="eg-tag">
                            <span>{s.city}</span>
                          </div>

                          <h1>{s.title}</h1>

                          <div className="banner-content-bottom mt-50">
                            <a href="#inquire-now" className="primary-btn4">
                              <span>Book a Trip</span>
                            </a>

                            {showWatchCulture && youtubeUrl ? (
                              <a
                                className="video-area"
                                href="#watch-culture"
                                onClick={openYoutube}
                              >
                                <div className="icon">
                                  <PlaySVG />
                                </div>
                                <h6 className="fw-bold">
                                  Watch Culture
                                </h6>
                              </a>
                            ) : null}
                          </div>
                        </div>
                      </Col>
                    </Row>
                  </Container>
                </div>
              ) : null}
            </div>
          </Carousel.Item>
        ))}
      </Carousel>

      {/* Video Modal */}
      <Modal show={showVideo} onHide={closeYoutube} centered size="xl">
        <Modal.Body style={{ padding: 0 }}>
          {showVideo && (
            <Ratio aspectRatio="16x9">
              <iframe
                src={`${youtubeEmbedUrl}?autoplay=1&mute=1`}
                title="video"
                allow="autoplay"
                allowFullScreen
              />
            </Ratio>
          )}
        </Modal.Body>
      </Modal>

      {/* Controls */}
      <div className="banner-vertical-controls">
        <button className="banner-ctrl" onClick={goPrev}>
          ↑
        </button>

        <div className="banner-ctrl-line">
          <div
            className="banner-ctrl-progress"
            style={{ height: `${progressPercent}%` }}
          ></div>
        </div>

        <button className="banner-ctrl" onClick={goNext}>
          ↓
        </button>
      </div>
    </div>
  );
}

function toEmbedUrl(url) {
  if (!url) {
    return "https://www.youtube.com/embed/ys8v5wAPF1w";
  }

  if (url.includes("/embed/")) {
    return url.split("?")[0];
  }

  const match = url.match(/(?:v=|youtu\.be\/)([\w-]+)/i);
  const videoId = match?.[1];

  return videoId ? `https://www.youtube.com/embed/${videoId}` : url;
}

export default BannerSlider;
